import { Google, Pixall } from 'reaxl-analytics-handlers';

import getBrandUnit from '@/analytics/utilities/getBrandUnit';

export function sendNotifyMeClick({
    dataLayer,
}, option) {
    const cmp = 'ntf_btn';

    Pixall.sendClickEvent(
        {
            label: cmp,
        },
        dataLayer,
        option
    );

    Google.sendClickEvent({
        eventElement: 'search-car',
        eventResult: 'cta::notify-me',
    }, option);

    return { cmp };
}

export function sendSubscribeClick({
    data = {},
    dataLayer,
    state,
}, option) {
    const { brand = '' } = state;

    const cmp = 'subscr_nft';

    Pixall.sendClickEvent(
        {
            label: cmp,
        },
        dataLayer,
        option
    );
    Google.sendClickEvent({
        ...data,
        eventAction: 'save',
        eventResult: 'save::search::email-notify',
        eventElement: getBrandUnit(brand),
    }, option);

    return { cmp };
}

export function sendCaptureSubscribeClick({
    dataLayer,
    data,
    state,
}, option) {
    const { brand = '' } = state;
    const cmp = 'subscr_srch';

    Pixall.sendClickEvent(
        {
            label: cmp,
        },
        dataLayer,
        option
    );

    Google.sendClickEvent({
        ...data,
        eventAction: 'save',
        eventResult: 'save::search::email-subscribe',
        eventElement: getBrandUnit(brand),
    }, option);

    return { cmp };
}

export function sendSubscribeAlertClick({
    dataLayer,
    event,
}, option) {
    const cmp = 'cta::subscribe';
    const { emailAddress } = event || {};

    if (emailAddress && window?.coxAutoDataLayer) {
        window.coxAutoDataLayer.push({
            user: {
                emailAddress,
            },
        });
    }

    Pixall.sendClickEvent(
        {
            eventSource: 'button',
            label: 'cta::subscribe',
            hasListingType: false,
            cdl: {
                eventProperties: {
                    action: 'Click',
                    element: 'Subscribe Price Drop Button',
                    tagIndex: 'ncf-004',
                },
            },
        },
        dataLayer,
        option
    );

    Google.sendClickEvent({
        eventElement: 'search-car',
        eventResult: 'cta::alert::subscribe::email',
    }, option);

    return { cmp };
}

export default {
    sendNotifyMeClick,
    sendSubscribeClick,
    sendCaptureSubscribeClick,
    sendSubscribeAlertClick,
};
